import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import Badge from "ui/components/Badge/Badge";

import { CronJob, CronJobEventType } from "services/api/cronjobs/types";
import { formatCronDateTime, formatDuration } from "services/api/cronjobs/transformations";

import CronJobStatusBadge from "../../components/CronJobStatusBadge/CronJobStatusBadge";
import CronJobExecutionStatusBadge from "../../components/CronJobExecutionStatusBadge/CronJobExecutionStatusBadge";

export const CRON_JOBS_COLUMNS: Column[] = [
  {
    title: "Vrsta obrade",
    field: "name",
    type: ColumnTypes.custom,
    render: (row: CronJob) => (
      <div>
        <div className="font-medium text-slate-800">{row.name}</div>
        <div className="text-xs text-slate-400 font-mono">{row.slug}</div>
      </div>
    ),
  },
  {
    title: "Opis",
    field: "description",
    type: ColumnTypes.custom,
    render: (row: CronJob) => <span className="text-slate-600">{row.description}</span>,
  },
  {
    title: "Status",
    field: "status",
    type: ColumnTypes.custom,
    render: (row: CronJob) => (
      <div className="flex items-center gap-2">
        <CronJobStatusBadge status={row.status} />
        {row.manualRun && <Badge text="Ručno pokretanje" variant="violet" height="small" />}
      </div>
    ),
  },
  {
    title: "Zadnja obrada",
    field: "lastExecution",
    type: ColumnTypes.custom,
    render: (row: CronJob) =>
      row.lastExecution ? (
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <CronJobExecutionStatusBadge status={row.lastExecution.status} />
            <span className="text-xs text-slate-400">
              {formatDuration(row.lastExecution.durationSeconds)}
            </span>
          </div>
          <span className="text-xs text-slate-500 whitespace-nowrap">
            {formatCronDateTime(row.lastExecution.started)}
          </span>
        </div>
      ) : (
        <span className="text-slate-400">—</span>
      ),
  },
  {
    title: "Sljedeće pokretanje",
    field: "nextRun",
    type: ColumnTypes.custom,
    render: (row: CronJob) => (
      <span className="text-sm text-slate-600 whitespace-nowrap">
        {formatCronDateTime(row.nextRun)}
      </span>
    ),
  },
  {
    title: "Obrade",
    field: "executionCount",
    type: ColumnTypes.custom,
    render: (row: CronJob) => <span className="text-slate-600">{row.executionCount}</span>,
  },
  {
    title: "",
    field: "actions",
    type: ColumnTypes.custom,
    render: (row: CronJob, onEventClick) => (
      <ButtonMenu endIcon="/media/icons/more-dots.svg" variant="text">
        <ButtonMenuItem
          startIcon="/media/icons/preview.svg"
          onClick={() => onEventClick(row.id, CronJobEventType.DETAIL)}
        >
          Detalji i obrade
        </ButtonMenuItem>
        <ButtonMenuItem
          startIcon="/media/icons/refresh.svg"
          disabled={!row.canResetStatus}
          tooltip={
            row.canResetStatus
              ? undefined
              : "Reset je moguć samo iz statusa 'U tijeku' ili 'Greška'"
          }
          onClick={() => row.canResetStatus && onEventClick(row.id, CronJobEventType.RESET_STATUS)}
        >
          Resetiraj status
        </ButtonMenuItem>
      </ButtonMenu>
    ),
  },
];
